var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"align-start",class:[
        _vm.$vuetify.breakpoint.smAndDown ? 'pa-0' : '',
        _vm.$route.meta.noPadding ? 'pa-0' : '',
        _vm.$route.meta.noBottomPadding ? 'pb-0' : 'pb-12'
    ],style:(_vm.$vuetify.breakpoint.smAndDown ? 'background-color: white' : ''),attrs:{"fluid":_vm.$route.meta.fluid === true || (_vm.$route.meta.lgAndDownFluid === true && _vm.$vuetify.breakpoint.lgAndDown)}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }